import React from 'react';
import { useTheme } from '../context/ThemeContext.js';

const Footer = () => {
  const { isLight } = useTheme();

  return (
    <footer className={`relative z-50 px-4 py-6 sm:px-8 sm:py-8 md:px-12 border-t ${
      isLight
        ? 'bg-background-light border-gray-200'
        : 'bg-background-dark border-white/5'
    }`}>
      <div className="max-w-[1600px] mx-auto flex flex-col gap-6 sm:gap-8">
        {/* Top row - Status and Version */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4 sm:gap-6">
            <div className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-chart-green rounded-full shadow-[0_0_8px_#00ff88]"></span>
              <span className={`text-[9px] sm:text-[10px] font-mono tracking-widest uppercase ${
                isLight ? 'text-gray-500' : 'text-white/60'
              }`}>System Online</span>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-4 sm:gap-10">
            <a href="#" className={`text-[9px] sm:text-[10px] uppercase tracking-widest transition-colors ${
              isLight ? 'text-gray-400 hover:text-gray-900' : 'text-white/40 hover:text-white'
            }`}>Research</a>
            <a href="#" className={`text-[9px] sm:text-[10px] uppercase tracking-widest transition-colors ${
              isLight ? 'text-gray-400 hover:text-gray-900' : 'text-white/40 hover:text-white'
            }`}>Models</a>
            <a href="#" className={`text-[9px] sm:text-[10px] uppercase tracking-widest transition-colors ${
              isLight ? 'text-gray-400 hover:text-gray-900' : 'text-white/40 hover:text-white'
            }`}>Firm</a>
            <a href="#" className={`text-[9px] sm:text-[10px] uppercase tracking-widest transition-colors ${
              isLight ? 'text-gray-400 hover:text-gray-900' : 'text-white/40 hover:text-white'
            }`}>Legal</a>
          </div>
        </div>

        {/* Bottom row */}
        <div className={`flex flex-col sm:flex-row sm:items-center justify-between gap-2 pt-4 sm:pt-0 border-t sm:border-0 ${
          isLight ? 'border-gray-200' : 'border-white/5'
        }`}>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
